import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';

const ItineraryOverview = ({ overviewRef, overview }) => (
  <div ref={overviewRef} id="overview-section" className="itinerary-overview-section">
    <h2><FaInfoCircle /> Tour Overview</h2>
    <p>{overview}</p>
  </div>
);

export default ItineraryOverview;
